
/* injects from baggage-loader */

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import SmartTable from '../../../../../components/smartTable';
import { goldenRaceSinglesColumnConfig } from './tableConfigs';
import { useState } from 'react';
import GoldenRaceSingle from '../single';
import { GameGroupTypeEnum } from '../../constants/enums';
import CasinoNumbers from '../../components/casinoNumbers';
import Helpers from '../../../../../helpers/helperFunctions';
import HorseNumbers from '../../components/horseNumbers';

const betsWithResult = [GameGroupTypeEnum.Lottery, GameGroupTypeEnum.Racing];

const GoldenRaceSingles = ({ allBets }) => {
    const { win_event, event } = allBets[0];
    const gameGroupName = event.gameGroupName;
    const betResults = betsWithResult.includes(gameGroupName) && win_event?.finalOutcome;

    const columnConfig = useMemo(goldenRaceSinglesColumnConfig, []);
    const [activeRowIndex, setActiveRowIndex] = useState(null);

    return <>
        <SmartTable
            data={allBets}
            columnConfig={columnConfig}
            rowClick={(e, row, rowIndex) => setActiveRowIndex(activeRowIndex === rowIndex ? null : rowIndex)}
            activeRowOpen={(row, rowIndex) => rowIndex === activeRowIndex}
            activeRowContent={row => <GoldenRaceSingle showFinalOutcome={false} allBets={[row]} />}
        />

        {betResults && <>
            {gameGroupName === GameGroupTypeEnum.Lottery && <CasinoNumbers numbers={betResults} />}
            {gameGroupName === GameGroupTypeEnum.Racing && <HorseNumbers horses={betResults}/>}
        </>}
    </>
};

GoldenRaceSingles.propTypes = {
    allBets: PropTypes.array.isRequired,
};

export default GoldenRaceSingles;